{
  "label": "Notifications",
  "arrear": "Payments overdue",
  "contract_termination_request_approval_needed": {
    "title": "Contract terminated",
    "content": "Approve or reject the change",
    "rightOfOccupancyNoticeTitle": "Notice of handover submitted"
  },
  "contract_termination_request_tenant_rejected": "Termination has been canceled because one tenant did not approve it.",
  "contract_termination_request_kenno_rejected": "Termination has been rejected. You will receive more information by email.",
  "message": "You have a new message",
  "viewMessages": "View messages",
  "contract_modification_request_approval_needed": {
    "title": "Tenant has resigned",
    "content": "Approve or reject the change"
  }
}
